import { useLocation, useParams } from "react-router-dom";
import useConceptDetails from "catalog/hooks/useConceptDetails";
import useConceptsLookup from "catalog/hooks/useConceptsLookup";
import {
  ConceptDetailsResponse,
  ConceptLookupResponse,
} from "catalog/types/interfaces/conceptResponse";
import { mapIdToLink } from "catalog/utils/concept";

const getNearestGroupInfo = (
  conceptDetails?: ConceptDetailsResponse,
  lookup?: ConceptLookupResponse
) => {
  const detailsData = Object.values(conceptDetails?.data ?? {}).find((details) => details);
  if (lookup) {
    // Search over parent IDs for groups with lookup details
    const validGroupLinks = detailsData?.parent_ids
      .map((id) => mapIdToLink(id, lookup))
      .filter((link) => link && !link.href.endsWith("/details"));
    // Return last in list (nearest to current detail)
    return validGroupLinks?.at(-1);
  }
};

/**
 * Helper hook to retrieve the nearest concept group regardless of whether you're
 * inside a nested concept detail or browsing the tree. Used by contextual search
 */
const useCurrentConceptGroup = () => {
  const location = useLocation();
  const { groupId, conceptId } = useParams();
  const isDetailsView = location.pathname.endsWith("/details");
  const { data: lookup } = useConceptsLookup();
  const { data: detailsResp } = useConceptDetails(conceptId);

  if (isDetailsView) {
    return getNearestGroupInfo(detailsResp, lookup);
  }

  if (groupId && lookup) {
    return mapIdToLink(groupId, lookup);
  }
};

export default useCurrentConceptGroup;
